<template>
  <div class="pc-page-settings__area-header">
    <slot/>
  </div>
</template>

<script>

export default {
  components: {
  }
}
</script>

<style lang="scss">
.pc-page-settings__area-header {
  font-size: 1.4rem;
  font-weight: bold;
  margin-bottom: 3rem;
}
</style>
